module.exports = __webpack_public_path__ + "static/img/logo.d0ab579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/logo.png
// module id = 7G4M
// module chunks = 57